(function($) {

	/**
	 * window, body
	 * @type {*|HTMLElement}
	 */
	var $win = $(window),
		$body = $('body');

	/**
	 * アンカースクロール
	 */
  var anchorScroll = function() {
    var ACTIVE_CLASS = 'is-active';

    $('a[href^="#"]').on('click', function(e) {

      // open street map のzoomは除外する
      var targetClassName = e.target.className
      if (targetClassName.startsWith('leaflet')) {
        return false
      }

      var speed = 500,
        href = $(this).attr("href"),
        $target = $(href === "#" || href === "" ? 'html' : href),
        position = $target.offset().top;
      if (href === '#fix-contact'){
        var fixed = $(this).parents('.top_fix_button_box').css('position')
        if (fixed !== 'fixed') {
          position = position - 61
        }
      }

      $('html, body').animate({scrollTop: position}, speed, "swing");
      return false;
    });
  };

	/**
	 * ページトップ表示・非表示
	 */
	var pageTopDisplay = function() {
		var $pageTop = $('[data-pagetop]'),
			scrollTop = 0,
			showPosition = window.innerHeight / 2;

		$win
			.on('scroll load', function() {
				scrollTop = $win.scrollTop();

				if (scrollTop >= showPosition) {
					$pageTop.fadeIn(100);
				} else {
					$pageTop.fadeOut(100);
				}
			})
			.on('resize', function() {
				showPosition = window.innerHeight / 2;
			});
	};

	/**
	 * document ready
	 */
	$(function() {
		anchorScroll();
		pageTopDisplay();
	});
})(jQuery);